export default "__VITE_ASSET__DvXoTtJ7__"